export default class UserDetailsService {
  constructor (Api) {
    this.api = Api;
  }

  getUserDetails (userId) {
    return this.api.get(`users/${userId}`);
  }
}
